import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { getSchemaAttrs, nodeToDOM } from '@common/util/schema';
import { NodeSpec } from 'prosemirror-model';

export class LinkSchemaPlugin extends SchemaPlugin {
  nodes = {
    link: {
      group: 'inline',
      inline: true,
      isLink: true,
      content: 'inline*',
      definingForContent: true,
      attrs: {
        alt: { default: undefined },
        href: { default: undefined },
        id: { default: undefined },
        name: { default: undefined },
        tabindex: { default: undefined },
        target: { default: undefined },
        title: { default: undefined }
      },
      parseDOM: [{
        tag: 'a',
        getAttrs(dom: HTMLElement) {
          return getSchemaAttrs(dom, ['alt', 'href', 'id', 'name', 'tabindex', 'target', 'title']);
        },
        preserveWhitespace: true
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'a',
      toDisplayName(node) {
        if (node.attrs.name && !node.attrs.href) {
          return 'MadCap:bookmark';
        } else {
          return 'a';
        }
      }
    },

    madcapcrossreference: {
      group: 'inline',
      inline: true,
      isLink: true,
      content: 'inline*',
      definingForContent: true,
      attrs: {
        href: { default: undefined },
        target: { default: undefined },
        title: { default: undefined },
        alt: { default: undefined },
      },
      parseDOM: [{
        tag: 'MadCap\\:xref',
        getAttrs(dom: HTMLElement) {
          return getSchemaAttrs(dom, ['href', 'target', 'title', 'alt']);
        },
        preserveWhitespace: true
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:xref'
    }
  } satisfies Record<string, NodeSpec>;
}
